const brotliDecompress = require('brotli/decompress')

export const BrotliMixin = {
  methods: {
    decompress(data) {
      this.$log.debug("descompress data")
      const buffDec = Buffer.from(data, 'base64');
      const decode = new TextDecoder().decode(brotliDecompress(buffDec))
      return JSON.parse(decode)
    }

  }
}
